import { SCREEN_SIZES } from 'modules/utils/screenSizes';
import { useMediaQuery } from 'react-responsive';
import { DesktopWeb } from './Web.desktop';
import { MobileWeb } from './Web.mobile';

export const Web = () => {
  const isMobile = useMediaQuery({
    query: `(max-width: ${SCREEN_SIZES.mobile})`,
  });

  if (isMobile) return <MobileWeb />;

  return <DesktopWeb />;
};
